import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

interface InviteArtistContextType {
  showInviteArtistDialog: boolean
  openInviteArtistDialog: () => void
  closeInviteArtistDialog: () => void
}

const InviteArtistContext = createContext<InviteArtistContextType | undefined>(undefined)

export function InviteArtistProvider({ children }: { children: ReactNode }) {
  const [showInviteArtistDialog, setShowInviteArtistDialog] = useState(false)

  const openInviteArtistDialog = useCallback(() => {
    setShowInviteArtistDialog(true)
  }, [])

  const closeInviteArtistDialog = useCallback(() => {
    setShowInviteArtistDialog(false)
  }, [])

  const value = useMemo(
    () => ({
      showInviteArtistDialog,
      openInviteArtistDialog,
      closeInviteArtistDialog,
    }),
    [closeInviteArtistDialog, openInviteArtistDialog, showInviteArtistDialog],
  )

  return <InviteArtistContext.Provider value={value}>{children}</InviteArtistContext.Provider>
}

export function useInviteArtistDialog() {
  const context = useContext(InviteArtistContext)
  if (context === undefined) {
    throw new Error('useInviteArtistDialog must be used within InviteArtistProvider')
  }
  return context
}
